import { Component, Inject } from '@angular/core';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISelection } from 'pbc.types';

import { FeldKategoriesQueryFilterConfig, IFeldKategoriesQueryShapes } from 'fa-kt.types';
import { FeldKategoriesService } from '../service';

@Component({
  selector: 'fa-kt-feld-kategories-filter',
  templateUrl: './feld-kategories-filter.component.html',
  styleUrls: ['./feld-kategories-filter.component.css'],
})
export class FeldKategoriesFilterComponent {
  readonly subscriptions: Subscription[] = [];

  FeldKategoriesFilterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public feldKategories: FeldKategoriesService,
  ) {
    this.FeldKategoriesFilterConfig = FeldKategoriesQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.feldKategories.shapes$.subscribe((shapes: IFeldKategoriesQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.FeldKategoriesFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.FeldKategoriesFilterConfig[index].selections = shapes;
  }
}
